"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.presentableDataClientFactory = exports.PresentableDataClient = void 0;
var axios_1 = __importDefault(require("axios"));
var qs_1 = __importDefault(require("qs"));
var PresentableDataClient = /** @class */ (function () {
    function PresentableDataClient(baseUrl, factorApiName, chartService) {
        var _this = this;
        this.baseUrl = baseUrl;
        this.factorApiName = factorApiName;
        this.chartService = chartService;
        this.paramsBuilderCommon = function (query) {
            var municipalities = query.municipalities, respondentType = query.respondentType;
            return {
                kommun: municipalities,
                factor: _this.factorApiName,
                type: respondentType,
            };
        };
        this.paramsBuilderMFV = function (query) {
            var _a;
            var yscales = query.yscales, describe = query.describe;
            var xscales = (_a = query.xscales) !== null && _a !== void 0 ? _a : _this.chartService.xScales;
            var year = query.years || _this.chartService.years;
            return __assign(__assign(__assign(__assign(__assign({}, _this.paramsBuilderCommon(query)), (year && { year: year })), (xscales && { xscale: xscales })), (yscales && { yscale: yscales })), (describe && { describe: describe }));
        };
        this.getMFVData = function (query) {
            var params = _this.paramsBuilderMFV(query);
            return _this.getPresentableRequest('MunicipalityFactorValues', params);
        };
        this.paramsBuilderSFB = function (query) {
            return __assign(__assign({}, _this.paramsBuilderMFV(query)), { "show_shares": false });
        };
        this.getSFBData = function (query) {
            var params = _this.paramsBuilderSFB(query);
            return _this.getPresentableRequest('SurveyFactorBoth', params);
        };
        this.getSFBMData = function (query) {
            var params = _this.paramsBuilderSFB(query);
            return _this.getPresentableRequest('SurveyFactorBothMulti', params);
        };
        this.paramsBuilderSSBC = function (query) {
            var year = query.year;
            year = year || _this.chartService.year;
            return __assign(__assign({}, _this.paramsBuilderCommon(query)), (year && { year: year }));
        };
        this.getBarChartData = function (query, presentableName) {
            var _a, _b, _c, _d;
            var params = _this.paramsBuilderSSBC(query);
            var yscales = (_a = _this.chartService.yScales) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; });
            if ("yscales" in query) {
                yscales = (_b = query.yscales) === null || _b === void 0 ? void 0 : _b.map(function (e) { return e; });
            }
            var xscales = (_c = _this.chartService.xScales) === null || _c === void 0 ? void 0 : _c.map(function (e) { return e; });
            if ("xscales" in query) {
                xscales = (_d = query.xscales) === null || _d === void 0 ? void 0 : _d.map(function (e) { return e; });
            }
            params = __assign(__assign(__assign({}, params), (xscales && { xscale: xscales })), (yscales && { yscale: yscales }));
            return _this.getPresentableRequest(presentableName, params);
        };
        this.getBarChartDataCombinedRespondents = function (query, presentableName) {
            query.respondentType = 'Företagare';
            return _this.getBarChartData(query, presentableName)
                .then(function (resultEntrepreneurs) {
                query.respondentType = 'Politiker';
                return _this.getBarChartData(query, presentableName)
                    .then(function (resultPoliticians) {
                    return [resultEntrepreneurs, resultPoliticians];
                });
            });
        };
        // I believe 'object' is the way to go here.
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.getPresentableRequest = function (presentableName, params) {
            return _this.getRequest(_this.baseUrl + "rest/graphs/" + presentableName + "/json", params);
        };
        // Adding some type gymnastics preventing direct call to this with presentable endpoint names
        // @see: https://github.com/microsoft/TypeScript/issues/4183
        // I believe 'object' is the way to go here.
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.getRequest = function (url, params) {
            return axios_1.default.get(url, {
                params: params,
                paramsSerializer: function (params) { return qs_1.default.stringify(params, { arrayFormat: 'repeat' }); },
                headers: { "Accept": "application/json" }
            }).then(function (r) { return r.data; }).catch(function (e) { return console.error(e); });
        };
    }
    return PresentableDataClient;
}());
exports.PresentableDataClient = PresentableDataClient;
exports.presentableDataClientFactory = function (apiBaseUrl, factorService) {
    return function (factorSlug, chartingLabel) {
        return new PresentableDataClient(apiBaseUrl, factorService.getApiName(factorSlug), factorService.getChartConfig(factorSlug, chartingLabel));
    };
};
